import { useSearchParams } from "react-router-dom";

const LAYOUT_PARAM = "layout";

export function useRundownLayout() {
	const [searchParams, setSearchParams] = useSearchParams();
	const layout = searchParams.get(LAYOUT_PARAM);

	const setLayout = (key: string | null) => {
		if (key) {
			searchParams.set(LAYOUT_PARAM, key);
		} else {
			searchParams.delete(LAYOUT_PARAM);
		}
		setSearchParams(searchParams);
	};

	return {
		layout,
		setLayout,
		isActive: (key: string) => layout === key,
	};
}
